/**
 * our harriApp passed to the function
 *
 * @type {Object} harriApp
 * @namespace RejectionTemplatesModal
 */
(function (app) {
    "use strict";

    /**
     * @typedef {Object} RejectionTemplatesModalController
     * This component shows the rejection template modal on template rejection settings page
     * You can find an example if your brand have the rejection template service
     * on 'HARRI_BASE_URL/settings/rejection_templates/brand/510569'
     */

    /**
     * Construct a new RejectionTemplatesModalController
     *
     * @class RejectionTemplatesModalController
     * @classdesc rejection modal controller.
     *
     * @constructor
     */
    var RejectionTemplatesModalController = function ($scope) {
        var self = this;

        /**
         * main container for every thing on rejection template module
         * @type {string}
         */
        var REJECTION_TEMPLATES = '.rejection-templates';
        /**
         * The rejection template modal container
         * @type {string}
         */
        var REJECTION_TEMPLATES_MODAL_CONTAINER = '.rejection-templates-modal';

        /**
         * This is a jQuery selector to show or hide the modal
         * @type {*|jQuery|HTMLElement}
         */
        var rejectionTemplatesModalContainer = $(REJECTION_TEMPLATES + REJECTION_TEMPLATES_MODAL_CONTAINER);

        /**
         * This is the container for bootstrap modal on this controller
         */
        var modal;

        /**
         * Events trigger from children components
         * @type {Object}
         */
        self.events = {};

        /**
         * This function hide modal on the children component
         * @type {Function[]}
         */
        self.events.hideModal = function () {
            self.hide();
        };

        /**
         * This function told modal that template edited or added
         * @type {Function[]}
         * @param {Object} item item
         */
        self.events.templateItemManaged = function (item) {
            self.hide();
            self.onSuccessManage({item: item});
        };

        /**
         * This function told modal that template deleted
         * @type {Function[]}
         * @param {number} id item id
         */
        self.events.templateItemDeleted = function (id) {
            self.hide();
            self.onDeletedItem({itemId: id});
        };

        /**
         * Public attributes attached to the scope
         *
         * Show the modal when needed
         * @type {Function[]}
         */
        self.show = function () {
            modal.modal('show');
        };

        /**
         * Hide modal when needed and clear template data then call the onHide function
         *
         * @type {Function[]}
         */
        self.hide = function () {
            delete self.rejectionTemplateItem;
            self.onHide();
            modal.modal('hide');
        };


        /**
         * Called on each controller after all the controllers on an element
         *
         * Check if the show modal var and show it
         *
         * @type {Function[]}
         */
        self.$onInit = function () {
            if (self.showModal) {
                self.show();
            }

            if (typeof (self.rejectionTemplateItem) !== 'undefined')  {
                self.rejectionTemplateItem = angular.copy(self.rejectionTemplateItem);
            }
        };

        /**
         * Called whenever one-way bindings are updated
         *
         * @type {Function[]}
         * @param {Object} changesObj
         * @param {Boolean} changesObj.showModal
         * @param {Object} changesObj.rejectionTemplateItem
         */
        self.$onChanges = function (changesObj) {

            if (
                typeof (changesObj.showModal) !== 'undefined' &&
                !changesObj.showModal.isFirstChange() &&
                JSON.stringify(changesObj.showModal.currentValue) !== JSON.stringify(changesObj.showModal.previousValue)
            ) {
                if (self.showModal) {
                    self.show();
                }
            }

            if (
                changesObj.rejectionTemplateItem &&
                !changesObj.rejectionTemplateItem.isFirstChange() &&
                JSON.stringify(changesObj.rejectionTemplateItem.currentValue) !== JSON.stringify(changesObj.rejectionTemplateItem.previousValue)
            ) {
                self.rejectionTemplateItem = angular.copy(changesObj.rejectionTemplateItem.currentValue);
            }
        };

        /**
         * Called after this controller's element and its children have been linked.
         * Get modal element to show or hide when needed, this method called one time.
         *
         * @type {Function[]}
         */
        self.$postLink = function () {
            modal = rejectionTemplatesModalContainer.find('.modal');

            modal.modal({
                show: false,
                keyboard: false,
                backdrop: 'static'
            });

            modal.on('hidden.bs.modal', function(e) {});
        };

        /**
         * Called on a controller when its containing scope is destroyed
         *
         * delete not needed element after destroy the component
         * @type {Function[]}
         */
        self.$onDestroy = function () {
            modal.remove();
        };
    };

    /**
     * The bindings attributes that bind to this component
     * @type {Object}
     */
    var RejectionTemplatesModal = {
        bindings: {
            showModal: '<',
            rejectionTemplateItem: '<',
            onHide: '&',
            brandId: '<',
            onSuccessManage: '&',
            onDeletedItem: '&',
            templates: '<'
        },
        transclude: true,
        templateUrl: '../modules/rejection-templates/components/manage-modal/manage-modal.html',
        controller: ['$scope', RejectionTemplatesModalController],
        controllerAs: 'RejectionTemplatesModal'
    };

    /**
     * Create the rejection template modal component using angular component
     */
    app.component('rejectionTemplatesModal', RejectionTemplatesModal);
})(angular.module('harriApp.rejectionTemplates'));